export const DS_ICON_CLASSES = {
  Base: "ds-icon",
  Spin: "ds-icon--spin",
};
